import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

import Tabla from '../../componentes/Tabla';

const VerClientes = ({ data, seleccionaRegistro, columns, setFilteredData }) => {
	const actions = [
		item => ({
			icon: () =>
				<button
					onClick={seleccionaRegistro(item, 'editar')}
					className="btn boton_estandar_blanco"
				><FontAwesomeIcon icon={faEdit} size="lg" />
				</button>
			,
			tooltip: "Editar"
		})
	]

	return (
		<Tabla data={data} actions={actions} columns={columns} CuentasFiltros setFilteredData={setFilteredData} />
	)
}

export default VerClientes